/* Progressive enhancement: keep wide policy tables within the page on mobile. */
(function () {
  'use strict';
  function enhance(root) {
    root.querySelectorAll('[data-cj-warranty-page] .cj-warranty-content table').forEach(function (table) {
      if (table.parentElement.classList.contains('cj-warranty-table-scroll')) return;
      var region = document.createElement('div');
      region.className = 'cj-warranty-table-scroll';
      region.setAttribute('role', 'region');
      var caption = table.querySelector('caption');
      region.setAttribute('aria-label', caption ? caption.textContent.trim() : 'Warranty information table');
      region.setAttribute('tabindex', '0');
      table.parentNode.insertBefore(region, table);
      region.appendChild(table);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  } else {
    enhance(document);
  }
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
}());
